import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CrossReferencesOpinionOption } from '../../../../types/product/crossess-refernces';
import { CrossReferenceNote } from '../../../../types/product/product';
import { orderBy } from 'lodash-es';

@Component({
    selector: 'app-assessment-notes',
    templateUrl: './assessment-notes.component.html',
    styleUrls: ['./assessment-notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AssessmentNotesComponent implements OnInit, OnChanges {
  @Input() defaultDropdown = 'Clinical Assessment';
  @Input() notes?: CrossReferenceNote[];
  @Input() crossReferenceOpinionOptions?: CrossReferencesOpinionOption[];
  @Input() canAddNotes = false;
  @Input() isOpinionDropdownVisible = true;
  @Input() canUpdateOpinion = false; // For dropdown list in add-notes tab.
  @Output() createNote = new EventEmitter();
  @Output() updateOpinion = new EventEmitter();

  activeTab = 1;
  noteMessage = '';
  selectedOption?: CrossReferencesOpinionOption | undefined;

  constructor() {}

  ngOnInit(): void {
    if (!this.notes?.length && this.canAddNotes) {
      this.activeTab = 2;
    }
  }

  onPopoverHidden() {
    this.noteMessage = '';
    this.setSelectedOption(undefined);
  }

  // Allow undefined because we want to reset the value when the popover is closed.
  setSelectedOption(selectedOption: CrossReferencesOpinionOption | undefined) {
    this.selectedOption = selectedOption;
  }

  onClickApply(
    noteMessage: string,
    selectedOption: CrossReferencesOpinionOption | undefined,
  ) {
    if (noteMessage) {
      this.createNote.emit(noteMessage);
    }

    if (selectedOption) {
      this.updateOpinion.emit({
        opinionOptionKey: selectedOption.optionKey,
        isExplicitSelection: true,
      });
    }

    this.noteMessage = '';
    this.activeTab = 1;
  }

  ngOnChanges({ notes }: SimpleChanges) {
    if (notes?.currentValue?.length) {
      this.notes = orderBy(
        notes.currentValue,
        'auditInfo.lastModifiedDate',
        'desc',
      );
    }
  }

  getIconClass(option: CrossReferencesOpinionOption) {
    return {
      'fa-thumbs-up green-text': option.opinion === 'approve',
      'fa-thumbs-down text-danger': option.opinion === 'dispute',
      'fa-square text-warning': option.opinion === 'review',
      'fa-times': option.opinion === 'no_opinion',
    };
  }
}
